import { render, staticRenderFns } from "./PWR01G01.vue?vue&type=template&id=7ffc8c0c&scoped=true"
import script from "./PWR01G01.vue?vue&type=script&lang=jsx"
export * from "./PWR01G01.vue?vue&type=script&lang=jsx"
import style0 from "./PWR01G01.vue?vue&type=style&index=0&id=7ffc8c0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc8c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffc8c0c')) {
      api.createRecord('7ffc8c0c', component.options)
    } else {
      api.reload('7ffc8c0c', component.options)
    }
    module.hot.accept("./PWR01G01.vue?vue&type=template&id=7ffc8c0c&scoped=true", function () {
      api.rerender('7ffc8c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pwr/PWR01G01.vue"
export default component.exports